<template>
  <div class="mb-4 col-lg-12 mb-lg-3">
    <div class="card z-index-2">
      <div class="p-3 card-body invoice-card" style="min-height: 400px">
        <p class="font-weight-bold">DB List</p>

        <div class="mt-3">
          <div class="row justify-content-center">
            <div
              class="col-md-6 col-lg-3 px-6 mb-3 text-center "
              v-for="(item, index) in dashoard_data?.db_list"
              :key="index"
            >
              <div >
                <div class="d-flex text-center m-3 align-items-center">
                  <div
                    class="text-center shadow icon icon-shape icon-xxs border-radius-sm me-2"
                    :class="`bg-gradient-${item?.color_code}`"
                  ></div>
                  <p class="text-uppercase mb-0 me-2">{{ item?.dbname }}</p>
                  <template v-if="hasPermission('2023')">
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    width="16" 
                    height="16" 
                    fill="#70d930" 
                    class="bi bi-download cursor-pointer"
                    @click.stop="downloadSingleCSV(item)"
                    viewBox="0 0 16 16"
                  >
                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"/>
                  </svg>
                  </template>
                </div>
                <p class="mb-0 text-xs cursor-pointer" @click="popup_open(item?.db_list, item?.dbname)">
                  <span
                    class="d-flex mx-auto justify-content-center align-items-center"
                    :class="`bg-gradient-${item?.color_code}`"
                    style="
                      padding: 10px;
                      width: 50px;
                      height: 50px;
                      border-radius: 100%;
                      color: white !important;
                    "
                  >
                    <b class="text-lg">{{ item?.db_count ?? 0 }}</b></span
                  >
                </p>
                <div class="progress w-100 bg-dark mt-3">
                  <div
                    class="progress-bar"
                    style="background-color: #70d930"
                    :class="`w-${Math.min(
                      Math.ceil(item?.db_count / 5) * 5,
                      100
                    )}`"
                    role="progressbar"
                    :aria-valuenow="item?.db_count"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="popup" class="col-6 text-end">
            <div class="popup_bg"></div>
            <div id="myModal" class="modal_class">
              <div class="modal-content invoice">
                <div class="d-flex justify-content-between">
                  <span>Name: {{ db_name }}</span>
                  <div>
                    <template v-if="hasPermission('2023')">
                    <button @click="downloadCSV" class="btn btn-sm btn-success me-2">
                      Download CSV
                    </button>
                    </template>
                    <span @click="popup_close" class="close">&times;</span>
                  </div>
                </div>

                <div
                  class="hover-popup my-3"
                  style="height: 500px; overflow-y: auto; scrollbar-width: thin"
                >
                  <div class="popup-content">
                    <table class="table">
                      <tbody>
                        <tr v-for="item in db_data" :key="item.PPPOE_ID">
                          <td class="text-left">
                            <strong>Olt:</strong>
                            {{ item.olt_connect__olt_name }}
                          </td>
                          <td class="text-left">
                            <strong>Port:</strong> {{ item.port_number }}
                          </td>
                          <td class="text-left">
                            <strong>PPPOE:</strong> {{ item.PPPOE_ID }}
                            <router-link
                              class="dark-filter text-info"
                              :to="{
                                name: 'Graph',
                                params: { pppoe: item.PPPOE_ID },
                              }"
                            >
                              <span
                                style="
                                  text-decoration: underline;
                                  font-size: 13px;
                                  color: #70d930 !important;
                                "
                                >View</span
                              >
                            </router-link>
                          </td>
                          <td class="text-left">
                            <strong>DB:</strong> {{ item.description }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps } from "vue";
import { hasPermission } from "@/utils/permissions.js";
import showSwal from "@/mixins/showSwal.js"; 

// Props (assumed)
const props = defineProps({
  dashoard_data: {
    type: Object,
    required: true,
  },
});
const popup = ref(false);
const db_data = ref([]);
const db_name = ref("");

const popup_open = (data, name) => {
  if (!hasPermission("2023")) {
    showSwal.methods.showSwal({
            type: "error",
              message: "You do not have permission to view data.",
            });
    return;
  }
  popup.value = true;
  db_data.value = data;
  db_name.value = name;
};
const popup_close = () => {
  popup.value = false;
  db_data.value = [];
  db_name.value = "";
};

const downloadSingleCSV = (dbItem) => {
  if (!hasPermission("2024")) {
    showSwal.methods.showSwal({
            type: "error",
              message: "You do not have permission to download data.",
            });
    return;
  }
  // Create CSV content for single DB
  const headers = ['OLT', 'Port', 'PPPOE ID', 'DB Description'];
  const csvContent = [
    headers.join(','),
    ...dbItem.db_list.map(item => [
      item.olt_connect__olt_name,
      item.port_number,
      item.PPPOE_ID,
      item.description
    ].join(','))
  ].join('\n');

  // Create and trigger download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `${dbItem.dbname}_data.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const downloadCSV = () => {
  if (!hasPermission("2024")) {
    showSwal.methods.showSwal({
            type: "error",
              message: "You do not have permission to download data.",
            });
    return;
  }
  // Create CSV content
  const headers = ['OLT', 'Port', 'PPPOE ID', 'DB Description'];
  const csvContent = [
    headers.join(','),
    ...db_data.value.map(item => [
      item.olt_connect__olt_name,
      item.port_number,
      item.PPPOE_ID,
      item.description
    ].join(','))
  ].join('\n');

  // Create and trigger download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `${db_name.value}_data.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Reference props in the template to prevent unused variable errors
const dashoard_data = props.dashoard_data;
</script>
